<div class="sidebar" #sidebar [class.open]="isOpen" [class.closed]="!isOpen">
  <!-- Header Section -->
  <div class="sidebar-header" [class.with-shadow]="hasHeaderShadow">
    <div class="header-container">
      <div class="header-content">
        <div class="menu-btn-wrapper">
          <button 
            class="menu-btn" 
            (click)="!isOpen ? toggleSidebar.emit() : newChat.emit()" 
            (mouseenter)="!isOpen && onMenuMouseEnter()"
            (mouseleave)="!isOpen && onMenuMouseLeave()"
            aria-label="Toggle sidebar"
          >
            <img 
              [src]="isOpen ? 'assets/icon.svg' : (isMenuHovered ? 'assets/custom-icons/menu.svg' : 'assets/icon.svg')" 
              [alt]="isOpen ? 'Icon' : 'Menu'"
              class="menu-icon"
            />
            <img 
              [src]="isOpen ? 'assets/icon.svg' : (isMenuHovered ? 'assets/custom-icons/menu.svg' : 'assets/icon.svg')" 
              [alt]="isOpen ? 'Icon' : 'Menu'"
              class="menu-icon-mobile"
            />
          </button>
        </div>
        <div class="right-menu-btn-wrapper" *ngIf="isOpen">
          <button 
            class="right-menu-btn" 
            (click)="toggleSidebar.emit()"
            aria-label="Toggle sidebar"
          >
            <img src="assets/custom-icons/menu.svg" alt="Menu" class="desktop-close-icon" />
            <img src="assets/custom-icons/close.svg" alt="Close" class="mobile-close-icon" />
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Actions Section -->
  <div class="actions-section">
    <button class="newchat-btn" (click)="onNewChat()">
      <img src="assets/custom-icons/newchat.svg" alt="New Chat" />
      <span class="newchat-text">New Chat</span>
    </button>
  </div>

  <!-- History Section -->
  <div class="history-section">
    <h3 class="history-header">Chats</h3>

    <ul *ngIf="conversations.length > 0; else noConversationsTemplate">
      <li *ngFor="let conversation of conversations">
        <a 
        (click)="openConversation(conversation.id)" 
        [class.active-link]="selectedChatId === conversation.id"
        [class.active-dropdown]="selectedMoreOptionsId === conversation.id"
      >
          <img
            *ngIf="conversation.mode === 'code' || conversation.mode === 'writing' || conversation.mode === 'image'"
            [src]="conversation.mode === 'image' ? 'assets/custom-icons/mode.svg' : 'assets/custom-icons/' + conversation.mode + '.svg'"
            [alt]="conversation.mode + ' chat'"
            class="conversation-mode-icon"
          />
          <span class="conversation-text">{{ conversation.title }}</span>
          <img 
            src="assets/custom-icons/more.svg" 
            alt="More Icon" 
            class="more-icon" 
            (click)="toggleMoreOptions(conversation.id, $event)" 
          />
        </a>
      </li>
    </ul>

    <ng-template #noConversationsTemplate>
      <div class="no-conversations">No Past Conversations</div>
    </ng-template>
  </div>

  <!-- Bottom: Dark mode toggle -->
  <div class="sidebar-footer">
    <button class="theme-btn" (click)="toggleTheme()" [title]="isDark ? 'Switch to light mode' : 'Switch to dark mode'">
      <!-- Moon icon (shown in light mode) -->
      <svg *ngIf="!isDark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
      </svg>
      <!-- Sun icon (shown in dark mode) -->
      <svg *ngIf="isDark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="5"/>
        <line x1="12" y1="1" x2="12" y2="3"/>
        <line x1="12" y1="21" x2="12" y2="23"/>
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
        <line x1="1" y1="12" x2="3" y2="12"/>
        <line x1="21" y1="12" x2="23" y2="12"/>
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
      </svg>
      <span class="theme-btn-text">{{ isDark ? 'Light mode' : 'Dark mode' }}</span>
    </button>
  </div>
</div>

<!-- Dropdown outside of sidebar to prevent clipping -->
<div 
  class="dropdown-container" 
  *ngIf="selectedMoreOptionsId" 
  [style.top.px]="dropdownPosition.top" 
  [style.left.px]="dropdownPosition.left">
  
  <button class="delete-btn" (click)="deleteConversation(selectedMoreOptionsId, $event)">
    <img src="assets/custom-icons/trash.svg" alt="Delete" class="trash-icon" />
    <span>Delete</span>
  </button>
</div>
